import { createContext } from 'react';

import type { Secret } from '@/modules/secrets';

export const SecretDetailContext = createContext<Secret | null>(null);
